import { Component, OnInit } from '@angular/core';
import { Utility } from '../../../shared/utility/utility';

import { FormValidationComponent } from '../../../form-validation/form-validation.component';

@Component({
  selector: 'app-custom-input',
  templateUrl: './custom-input.component.html',
  styleUrls: ['./custom-input.component.scss']
})
export class CustomInputComponent extends FormValidationComponent implements OnInit {

  errorMessage = 'Full name is missing, please fill in fields marked in red';
  constructor(
    private utils: Utility,
  ) {
    super(utils);
   }

  ngOnInit(): void {
  }

}
